export default __webpack_public_path__ + "static/media/ok.f154e311.svg";